module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-100.5cb7edf.woff";